import { render, staticRenderFns } from "./DeliveryCard.vue?vue&type=template&id=30d13189&scoped=true"
import script from "./DeliveryCard.vue?vue&type=script&lang=js"
export * from "./DeliveryCard.vue?vue&type=script&lang=js"
import style0 from "./DeliveryCard.vue?vue&type=style&index=0&id=30d13189&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d13189",
  null
  
)

export default component.exports